import { useEffect } from 'react';
import { useUserContext } from '../../../../../contexts/UserContext';
import { FEATURE_FREE_HISTORY_CHECK } from '../../../../../utils';
import { useBraze } from '../../../../../hooks/useBraze';
import {
  isCarsSection,
  isElectric,
  isOver20k,
} from './ListingViewBrazeTracking.constants';

type UseAdpBrazeEventsProps = {
  adId: number;
  priceEuro?: number | null;
  sellerType: string | undefined;
  fuelType: string | null;
  sectionName: string | undefined;
  location: string | undefined;
  isFreeHistoryCheckReport: boolean;
};

const useAdpBrazeEvents = (props: UseAdpBrazeEventsProps) => {
  const {
    adId,
    priceEuro,
    sellerType,
    fuelType,
    location,
    sectionName,
    isFreeHistoryCheckReport,
  } = props;
  const { isBrazeInitialized } = useUserContext();
  const {
    logBrazeViewAdEvent,
    logBrazeViewAd20kEvent,
    logBrazeViewAdEvEvent,
    logBrazeFreeHistoryCheckAdView,
  } = useBraze();

  useEffect(() => {
    if (!isBrazeInitialized) return;
    const eventInput = {
      ad_id: adId.toString(),
      ad_price: (priceEuro ?? '').toString(),
      seller_type: sellerType ?? '',
    };

    if (isCarsSection(sectionName)) {
      logBrazeViewAdEvent(eventInput);

      if (isOver20k(priceEuro)) {
        logBrazeViewAd20kEvent(eventInput);
      }

      if (isElectric(fuelType)) {
        logBrazeViewAdEvEvent(eventInput);
      }
    }

    if (FEATURE_FREE_HISTORY_CHECK && isFreeHistoryCheckReport) {
      logBrazeFreeHistoryCheckAdView({
        ad_id: adId.toString(),
        category: sectionName ?? '',
        location: location ?? '',
        ad_price: (priceEuro ?? '').toString(),
      });
    }
  }, [
    isBrazeInitialized,
    isFreeHistoryCheckReport,
    logBrazeViewAdEvEvent,
    logBrazeViewAdEvent,
    logBrazeViewAd20kEvent,
    logBrazeFreeHistoryCheckAdView,
    adId,
    sectionName,
    location,
    priceEuro,
    sellerType,
    fuelType,
  ]);
};

export { useAdpBrazeEvents };
